import { useState, useEffect } from 'react'
import { getProduct } from '@lib/firestore'

const useProduct = id => {
  const [product, setProduct] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchProduct = async () => {
      const product = await getProduct(id)
      setProduct(product)
      setLoading(false)
    }
    fetchProduct()
  }, [id])

  return { product, loading }
}

export default useProduct
